import React, { useState, useEffect } from 'react';
import StaffSidebar from './StaffSidebar';
import LMSTopBar from './LMSTopBar';
import { cn } from '@/lib/utils';

interface StaffLayoutProps {
    children: React.ReactNode;
    title: string;
    userName?: string;
}

const StaffLayout = ({ children, title, userName = "Staff Administrator" }: StaffLayoutProps) => {
    // Persistent collapsed state (optional, but good for UX)
    const [isCollapsed, setIsCollapsed] = useState(() => {
        const saved = localStorage.getItem('staff-sidebar-collapsed');
        return saved ? JSON.parse(saved) : false;
    });

    useEffect(() => {
        localStorage.setItem('staff-sidebar-collapsed', JSON.stringify(isCollapsed));
    }, [isCollapsed]);

    const toggleSidebar = () => setIsCollapsed(!isCollapsed);

    return (
        <div className="flex min-h-screen bg-gray-50">
            {/* Sidebar */}
            <StaffSidebar
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
            />

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                <LMSTopBar
                    title={title}
                    userName={userName}
                    onMenuClick={toggleSidebar}
                    isSidebarCollapsed={isCollapsed}
                />

                <main className="flex-1 overflow-y-auto p-8 pb-20">
                    <div className="max-w-7xl mx-auto">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default StaffLayout;
